import { graphql } from "gql.tada";

export const IconGridFragment = graphql(`
  fragment IconGridFragment on IconGrid {
    _id
    displayTitle
    iconsCollection(limit: 32) {
      items {
        _id
        iconTitle
        iconimage {
          url
          contentType
        }
      }
    }
  }
`);
